import {
  IN_TIME_INSTALLED_SOFT,
  IS_SHOW_MENU_SPOT,
  SET_ABOUT_VISIBLE,
  SET_CAN_BACK,
  SET_CHECK_UPDATE_VISIBLE,
  SET_DETAIL_COMMENT_VISIBLE,
  SET_DOWNLOAD_PATH_VISIBLE,
  SET_DOWNLOAD_VISIBLE,
  SET_FIRST_RUN,
  SET_HOT_LENOVO_VISIBLE,
  SET_IFRAME_VISIBLE,
  SET_IS_ENABLED_SILENT,
  SET_MENU_ACTIVE,
  SET_NEW_VERSION_INFO,
  SET_OPERATION_MENU_VISIBLE,
  SET_PHONE_VISIBLE,
  SET_PINPOP_CLOSE_VISIBLE,
  SET_PINPOP_VISIBLE,
  SET_RELEASE_NOTES_VISIBLE,
  SET_SEARCH_KEYWORD,
  SET_TICK,
  SET_USER_FEEDBACK_VISIBLE,
  SET_TOP_IMG_VIDEO_VISIBLE,
  SET_SHARE_VISIBLE,
  SET_SHARE_LINK,
  SET_FASTER_PRODUCT,
  SET_MAXIMIZE,
  SET_MESSAGE_VISIBLE,
  SET_MESSAGE_ACTIVE_TAB,
} from '../constants/layout';

export function setActiveMenu(pathname) {
  return {
    type: SET_MENU_ACTIVE,
    pathname,
  };
}

export function setSearchKeyWord(kw) {
  return {
    type: SET_SEARCH_KEYWORD,
    keyword: kw,
  };
}

export function setTick(visible) {
  return {
    type: SET_TICK,
    visible,
  };
}

export function setCanBack(canback) {
  return {
    type: SET_CAN_BACK,
    canback,
  };
}
export const setFirstRun = firstRun => ({
  type: SET_FIRST_RUN,
  firstRun,
});

export function setHotLenovoVisible(visible) {
  return {
    type: SET_HOT_LENOVO_VISIBLE,
    visible,
  };
}

export function setPinPopVisible(visible) {
  return {
    type: SET_PINPOP_VISIBLE,
    visible,
  };
}

export function setPinPopCloseVisible(visible) {
  return {
    type: SET_PINPOP_CLOSE_VISIBLE,
    visible,
  };
}

export function setDownloadPathVisible(visible) {
  return {
    type: SET_DOWNLOAD_PATH_VISIBLE,
    visible,
  };
}

export function setOperationMenuVisible(visible) {
  return {
    type: SET_OPERATION_MENU_VISIBLE,
    visible,
  };
}

export function setDownloadVisible(visible) {
  return {
    type: SET_DOWNLOAD_VISIBLE,
    visible,
  };
}

export function setAboutVisible(visible) {
  return {
    type: SET_ABOUT_VISIBLE,
    visible,
  };
}
//  ������-������
export function setCheckUpdateVisible(visible) {
  return {
    type: SET_CHECK_UPDATE_VISIBLE,
    visible,
  };
}

// ���� �°汾��Ϣ
export function setNewVersionInfo(newVersionInfo) {
  return {
    type: SET_NEW_VERSION_INFO,
    newVersionInfo,
  };
}

export function setPhoneVisible(visible) {
  return {
    type: SET_PHONE_VISIBLE,
    visible,
  };
}

export function setInTimeInstalledSoft(inTimeInstSoft) {
  return {
    type: IN_TIME_INSTALLED_SOFT,
    inTimeInstSoft,
  };
}

export const setMenuSpot = isShowMenuSpot => ({
  type: IS_SHOW_MENU_SPOT,
  isShowMenuSpot,
});

export const setIsEnabledSilent = isEnabledSilent => ({
  type: SET_IS_ENABLED_SILENT,
  isEnabledSilent,
});

export const setIframeVisible = param => ({
  type: SET_IFRAME_VISIBLE,
  param,
});

export const setDetailCommentVisible = param => ({
  type: SET_DETAIL_COMMENT_VISIBLE,
  param,
});

export const setReleaseNotesVisible = visible => ({
  type: SET_RELEASE_NOTES_VISIBLE,
  visible,
});

export const setUserFeedbackVisible = visible => ({
  type: SET_USER_FEEDBACK_VISIBLE,
  visible,
});

export const setTopImgVideoVisible = param => ({
  type: SET_TOP_IMG_VIDEO_VISIBLE,
  param,
});

export const setShareVisible = visible => ({
  type: SET_SHARE_VISIBLE,
  visible,
});

export const setShareLink = link => ({
  type: SET_SHARE_LINK,
  link,
});

export const setFasterProduct = payload => ({
  type: SET_FASTER_PRODUCT,
  payload,
});

export const setMaximize = payload => ({
  type: SET_MAXIMIZE,
  payload,
});

export const setMessageVisible = visible => ({
  type: SET_MESSAGE_VISIBLE,
  visible,
});

export const setMessageActiveTab = payload => ({
  type: SET_MESSAGE_ACTIVE_TAB,
  payload,
});
